import Link from "../../utils/Link";
import * as React from "react";
import useTranslations from "../../../hooks/useTranslations";
import { BuildingIcon } from "../../icons";
import Activity from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import { ActivityFragment, CompanyMinimalFragment, GroupFragment } from '../../../graphql/generated/definitions';

type GroupCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: GroupFragment;
};

export function isGroupCreatedActivity(
  q: ActivityFragment
): q is GroupCreatedActivity {
  return q.key === "group.created";
}

interface GroupCreatedActivityProps {
  activity: GroupCreatedActivity;
}

export const GroupCreatedActivity: React.FC<GroupCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="groupCreatedActivity"
      visual={<BuildingIcon className="w-10 h-10 text-accent-500" />}
    >
      <Text fontSize="sm">
        {t("activity.labels.groupCreated", {
          group: (
            <Link to={`/users?groupId=${activity.trackable.id}`}>
              {activity.trackable.name}
            </Link>
          ),
        })}
      </Text>
    </Activity>
  );
};
